<template>
  <el-drawer :title="`任务书 ID: ${briefId}`" :visible.sync="drawer" direction="rtl" size="60%">
    <el-tabs type="card" v-model="tabValue" @tab-click="handleTabsEdit" class="flex-tabs mt-4">
      <el-tab-pane label="任务书内容" name="1"></el-tab-pane>
      <el-tab-pane label="签署情况" name="2"></el-tab-pane>
    </el-tabs>
    <div style="height: calc(100% - 65px);" v-if="tabValue === '1'" class="p-6 pt-0 box-border overflow-auto">
      <p class="text-theme-black-850 text-medium-x font-semibold text-center mb-4">{{ detailData.briefTitle }}</p>
      <div class="leading-22" v-html="detailData.briefContent"></div>
    </div>
    <div style="height: calc(100% - 65px);" v-else class="p-6 pt-0 box-border overflow-auto">
      <p class="text-theme-black-850 leading-22 text-medium mb-4"><span class="text-danger mr-0.5">*</span>1. 我已熟读并知悉项目任务书的所有信息和要求，并认可按照上述要求执行本项目。手写签名</p>
      <div class="rounded-small mb-6 ml-3" style="width: 327px; height: 192px; background: #F5F5F5;">
        <img width="327" height="192" :src="detailData.signatureImg"/>
      </div>
      <p class="text-theme-black-850 leading-22 text-medium mb-4"><span class="text-danger mr-0.5">*</span>2. 责任人基础信息填写</p>
      <label class="text-theme-black-850 leading-22 text-medium mb-2 block ml-3">责任人：</label>
      <el-input class="bg-white-input border-input ml-3 mb-4" style="width:455px" placeholder="请输入" disabled v-model="detailData.staffName"  />
      <label class="text-theme-black-850 leading-22 text-medium mb-2 block ml-3">身份证号：</label>
      <el-input class="bg-white-input border-input ml-3 mb-4" style="width:455px" placeholder="请输入" disabled v-model="detailData.identNo"  />
      <label class="text-theme-black-850 leading-22 text-medium mb-2 block ml-3">调研工厂已注册手机号：</label>
      <el-input class="bg-white-input border-input ml-3 mb-6" style="width:455px" placeholder="请输入" disabled v-model="detailData.staffPhone"  />
      <p class="text-theme-black-850 leading-22 text-medium mb-4"><span class="text-danger mr-0.5">*</span>3.身份证人像面照片</p>
      <div class="rounded-small mb-6 ml-3" style="width: 280px; background: #F5F5F5;">
        <img width="280" height="192" :src="detailData.idCardFront"/>
      </div>
      <p class="text-theme-black-850 leading-22 text-medium mb-4"><span class="text-danger mr-0.5">*</span>4.身份证国徽面照片</p>
      <div class="rounded-small mb-6 ml-3" style="width: 280px; background: #F5F5F5;">
        <img width="280" height="192" :src="detailData.idCardBack"/>
      </div>
      <p class="text-theme-black-850 leading-22 text-medium mb-4"><span class="text-danger mr-0.5">*</span>5.无犯罪记录证明</p>
      <el-input v-if="detailData.noCriminalFileName" class="ml-3" style="width:238px" placeholder="" disabled v-model="detailData.noCriminalFileName" />
      <el-button v-if="detailData.noCriminalFileName" type="text" class="ml-6" @click="preview">预览</el-button>
      <el-button v-if="detailData.noCriminalFileName" type="text" @click="download">下载</el-button>
      <span v-if="!detailData.noCriminalFileName" class="text-theme-black-850 leading-22 text-medium ml-3">无数据</span>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :initialIndex="0"
      :on-close="()=>{ showViewer=false }"
      :url-list="[detailData.noCriminalPath]"
      :z-index="5000"
    />
  </el-drawer>
</template>
<script>
import { signDetail } from '@/api/project-task/setting'
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    briefId: {
      type: String,
      default: ''
    },
    tab: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      detailData: {},
      showViewer: false
    }
  },
  computed: {
    drawer: {
      set(v) {
        this.$emit('update:visible', v)
      },
      get() {
        if(this.visible) {
          this.getDetail()
        }
        return this.visible
      }
    },
    tabValue: {
      set(v) {
        this.$emit('update:tab', v)
      },
      get() {
        return this.tab
      }
    }
  },
  methods: {
    // getDownloadUrl(url) {
    //   let baseURL = window.location.origin
    //   return baseURL + '/fill/api/v1/download?fileName=' + url
    // },
    handleTabsEdit() {

    },
    getDetail() {
      signDetail(this.id).then(res => {
        this.detailData = res.data.data
      }).catch(err=> {

      })
    },
    preview() {
      this.showViewer = true
    },
    download() {
      window.open(this.detailData.noCriminalPath, '_blank', `download=${this.detailData.noCriminalFileName}`)
    },
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .flex-tabs .el-tabs__nav .el-tabs__item {
    flex: none;
  }
</style>